import FormattedMessage from 'I18n/components/FormattedMessage';
import { BaseSaveViewActionButton } from './BaseSaveViewActionButton';
import { useCanUserWriteViews } from '../../utils/hooks/useCanUserWriteViews';
import { DuplicateIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloneButton = ({
  onClick,
  isDisabled = false
}) => {
  const canUserWriteViews = useCanUserWriteViews();
  if (!canUserWriteViews) {
    return /*#__PURE__*/_jsx(BaseSaveViewActionButton, {
      "data-test-id": "save-view-buttons__clone",
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.saveViewButtons.tooltips.cloneNotPermissioned"
      }),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(DuplicateIcon, {
        size: "200"
      })
    });
  }
  if (isDisabled) {
    return /*#__PURE__*/_jsx(BaseSaveViewActionButton, {
      "data-test-id": "save-view-buttons__clone",
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.saveViewButtons.tooltips.cloneDisabled"
      }),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(DuplicateIcon, {
        size: "200"
      })
    });
  }
  return /*#__PURE__*/_jsx(BaseSaveViewActionButton, {
    "data-test-id": "save-view-buttons__clone",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.saveViewButtons.tooltips.clone"
    }),
    onClick: onClick,
    use: "tertiary-extra-light",
    children: /*#__PURE__*/_jsx(DuplicateIcon, {
      size: "200"
    })
  });
};